// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractAnnulationController = function ($scope, $routeParams, $location, $http, Contract, ProductInfo) {
    $scope.annulationClicked = false;
    var productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.plan.PlanGroupId);
        });
    });

    $scope.annulateContract = function () {
        $scope.annulationClicked = true;
        $http({
            method: "POST", url: "/api/v1/contracts/" + $routeParams.contractId + "/annulate", params: null,
            data: {}, headers: {}, cache: false
        }).then(function () {
            $location.path("/contracts/" + $routeParams.contractId);
        }, function () {
            $scope.annulationClicked = false;
        });
    };
};
ContractAnnulationController.$inject = ['$scope', '$routeParams', '$location', '$http', 'Contract', 'ProductInfo'];
